// extracted by mini-css-extract-plugin
module.exports = {"saleBox":"_1vxEM","con":"o8rc5","trend":"_2O5PG","number":"_2HHSb","sub":"_2WC6_","noData":"_2gxoe","comingSoon":"_34Huh"};